<div class="col-12 pt-3">
  <div class="row">
    <div class="col-9 p-0">
      <app-wizard-head [wizardInput]="wizardInput"></app-wizard-head>
    </div>
    <div class="col-3 saveContinue">
      <!-- <button mat-raised-button color="primary">Save & Continue</button> -->
    </div>
  </div>
</div>

<div class="row py-3" *ngIf="isDataLoaded && isRequestDataDocuments">
  <div class="col-12 px-0">
    <app-request-data-documents class="w-100" [beneficiaryData]="benDataForReqDataDoc" [isWizard]="true"
      [wizardData]="primaryData" (onSaveCancel)="cancelReqDataDocs($event)"></app-request-data-documents>
  </div>
</div>
<div class="row py-3"
  *ngIf="requestDataResponseBen && !isRequestDataDocuments && (showErrorBanner || showSuccessBanner)">
  <div class="col-12 px-0 d-flex justify-content-center">
    <div class="notification-banner error" [hidden]="!showErrorBanner"
      *ngIf="requestDataResponseBen?.status?.code === 'PENDING'">
      <p>The individual has not yet filled the necessary details.</p>
      <button pButton pRipple type="button" icon="pi pi-bell" class="p-button-rounded p-button-text mr-1 ml-2"
        (click)="confirmResend()"></button>
      <span (click)="confirmResend()">Send Reminder</span>
      <button pButton pRipple type="button" icon="pi pi-times"
        class="p-button-rounded p-button-secondary ml-3 btn-close-black" (click)="showErrorBanner = false"></button>
    </div>
    <div class="notification-banner success" [hidden]="!showSuccessBanner"
      *ngIf="requestDataResponseBen?.status?.code === 'COMPLETED'">
      <p>Individual has filled the data on: {{requestDataResponseBen?.filledDate || '--'}}</p>
      <button pButton pRipple type="button" icon="pi pi-times"
        class="p-button-rounded p-button-secondary ml-3 btn-close-black" (click)="showSuccessBanner = false"></button>
    </div>
    <div class="request-data-again" [hidden]="!showSuccessBanner"
      *ngIf="requestDataResponseBen?.status?.code === 'COMPLETED'">
      <button pButton type="button" class="p-button-text" label="Request Data Again"
        (click)="requestDataAgain()"></button>
    </div>
  </div>
</div>

<!-- <div class="d-flex justify-content-center mt-4" *ngIf="!isRequestDataDocuments">
  <mat-button-toggle-group [value]="selectedProfile" (change)="onChange($event)">
    <mat-button-toggle value="simple">Simple Profile</mat-button-toggle>
    <mat-button-toggle value="complete">Complete Profile</mat-button-toggle>
  </mat-button-toggle-group>
</div> -->

<ng-container *ngIf="isDataLoaded && !isRequestDataDocuments">
  <!-- <div *ngIf="selectedProfile === 'simple'"> -->
  <div class="mt-4" id="simpleProfile">
    <p>
      <app-immigration-document-upload  [primaryData]="primaryData"
        (formDetailsChange)="onFormDetailsChange($event)"></app-immigration-document-upload>
    </p>
    <p-accordion [activeIndex]="0">
      <p-accordionTab header="Individual Details" (click)="onClicksimpleAccordion(1)">
        <p>
          <lib-generic-beneficiary-personal-details-library (profileEditStatus)="onEditClicked($event)"
            (personalDetails)="personalDetails($event)" [detailsAbout]="selectedDetailAbout"
            [isShowVerify]="false"  [passportShow]="true"  (hasPassportChange)="onHasPassportChange($event)" [editMode]="true" [isShowProfilePic] = "false"
            [formDetails]="formDetails" [primaryData]="primaryData" [documentType]="documentType">
          </lib-generic-beneficiary-personal-details-library>

        </p>
      </p-accordionTab>
      <p-accordionTab header="Education" (click)="onClicksimpleAccordion(2)">
        <p>
          <lib-generic-beneficiary-education [isUsedForBeneEdit]="false" [inputData]="primaryData" [isWizard]="true" [formDetails]="formDetails" [documentType]="documentType">
          </lib-generic-beneficiary-education>
        </p>
      </p-accordionTab>
      <p-accordionTab header="Experience" (click)="onClicksimpleAccordion(3)">
        <p>
          <lib-generic-beneficiary-work-experience [primaryData]="primaryData" [isWizard]="true" [formDetails]="formDetails" [documentType]="documentType">
          </lib-generic-beneficiary-work-experience>
          <!-- <lib-simple-experience-detail-library [isWizard]="true" [wizardData]="primaryData" [formDetails]="formDetails"
            [documentType]="documentType"></lib-simple-experience-detail-library> -->
        </p>
      </p-accordionTab>
      <p-accordionTab header="Immigration" (click)="onClicksimpleAccordion(4)">
        <p>
          <!-- <simple-immigration-detail-library [primaryData]="primaryData"></simple-immigration-detail-library> -->
          <lib-generic-beneficiary-immigration-details-library [isWizard]="true" [inputData]="primaryData"></lib-generic-beneficiary-immigration-details-library>
        </p> 
      </p-accordionTab>
      <p-accordionTab header="All Documents" (click)="onClicksimpleAccordion(5)">
        <lib-document-checklist-library *ngIf="docsimpleStatus"
          [primaryData]="primaryData"></lib-document-checklist-library>
      </p-accordionTab> 
    </p-accordion>
  </div>
  <!-- </div> -->

  <!-- <div *ngIf="selectedProfile === 'complete'">
    <div class="mt-4" id="completeProfile">
      <p-accordion [activeIndex]="0">
        <p-accordionTab header="Individual Details" (click)="onClickAccordion(1)">
          <div class="wizard-form-holder">
          
          </div>
        </p-accordionTab>
        <p-accordionTab header="Education" (click)="onClickAccordion(2)">
          <div class="wizard-form-holder">
            <edit-education-details-tab *ngIf="primaryDataCompletedBeneficiaryEducationDetails"
              [editEducationData]="primaryDataCompletedBeneficiaryEducationDetails"></edit-education-details-tab>
          </div>
        </p-accordionTab>
        <p-accordionTab header="Experience" (click)="onClickAccordion(3)">
          <div class="wizard-form-holder">
            <edit-work-experience-details *ngIf="primaryDataCompletedBeneficiaryExperienceDetails"
              [primaryData]="primaryDataCompletedBeneficiaryExperienceDetails"></edit-work-experience-details>
          </div>
        </p-accordionTab>
        <p-accordionTab header="Immigration" (click)="onClickAccordion(4)">
          <beneficiary-documents-edit-library></beneficiary-documents-edit-library>
        </p-accordionTab>
        <p-accordionTab header="All Documents" (click)="onClickAccordion(5)">
          <lib-document-checklist-library *ngIf="docStatus"
            [primaryData]="primaryData"></lib-document-checklist-library>
        </p-accordionTab>
      </p-accordion>
    </div>
  </div> -->
</ng-container>

<p-confirmDialog styleClass="confirm-resend-request-data" id="data-log-modal"
  [style]="{width: '50vw'}"></p-confirmDialog>